import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

const FunnelSection = ({
  width,
  backgroundColor,
  title,
  tooltip,
}: {
  width: string;
  backgroundColor: string;
  title?: string;
  tooltip?: string;
}) => {
  return (
    <Box
      sx={{
        transform: "rotate(180deg)",
        position: "relative",
        width,
        height: "96px",
        margin: "8px auto",
        "& .tooltip": {
          transfrom: {
            xs: "translateX(-50%) rotate(180deg) scale(0)",
            md: "translate(-100%, -50%) rotate(180deg) scale(0)",
          },
          opacity: 0,
        },
        "&:hover .tooltip": {
          transfrom: {
            xs: "translateX(-50%) rotate(180deg) scale(1)",
            md: "translate(-100%, -50%) rotate(180deg) scale(1)",
          },
          opacity: 1,
        },
        "&:hover .shape": {
          transform: "perspective(10px) rotateX(0.5deg) scale(1.05)",
          boxShadow: "0 -4px 18px rgba(0, 0, 0, 0.4)",
        },
        "&:hover .text": {
          transform: "translate(-50%, -50%) rotate(180deg) scale(1.05)",
        },
      }}
    >
      <Box
        className="shape"
        sx={{
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          backgroundColor,
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          transform: "perspective(10px) rotateX(0.5deg)",
        }}
      />
      <Box
        className="text"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) rotate(180deg)",
          transition: "transform 0.3s ease",
          color: "#000",
        }}
      >
        <Typography variant="h6">{title || "Funnel Section"}</Typography>
      </Box>

      <Paper
        className="tooltip"
        elevation={5}
        sx={{
          transition: "transform 0.3s ease, opacity 0.3s ease",
          pointerEvents: "none",
          position: "absolute",
          top: {
            xs: "0%",
            md: "50%",
          },
          left: {
            xs: "50%",
            md: "10%",
          },
          right: "auto",
          transform: {
            xs: "translateX(-50%) rotate(180deg)",
            md: "translate(-100%, -50%) rotate(180deg)",
          },
          color: "#000",
          p: 1,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ maxWidth: "298px" }}
        >
          <ArrowCircleRightIcon color="success" />
          <Typography variant="caption">{tooltip || "tooltip"}</Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export const Funnel = () => {
  const widthFactor = window.innerWidth <= 768 ? window.innerWidth : 768;
  const getWidth = (percentage: number) => {
    return `${percentage * widthFactor}px`;
  };

  return (
    <Container>
      <FunnelSection
        width={getWidth(0.9)}
        backgroundColor="#C0CA33"
        title="Impressions"
        tooltip="# of target households per territory,
determines # of impressions needed to 
start the funnel.   "
      />

      <FunnelSection
        width={getWidth(0.82)}
        backgroundColor="#CDDC39"
        title="Awareness"
        tooltip="% of households that convert from an impression
(seeing our ads) to understanding.  "
      />

      <FunnelSection
        width={getWidth(0.75)}
        backgroundColor="#D4E157"
        title="Engagement"
        tooltip="% of households that convert from
understanding to interested."
      />

      <FunnelSection
        width={getWidth(0.68)}
        backgroundColor="#DCE775"
        title="Leads"
        tooltip="% of households that convert 
from interested to sign up."
      />

      <FunnelSection
        width={getWidth(0.62)}
        backgroundColor="#E6EE9C"
        title="Matches"
        tooltip="% of households that sign up,
then match. "
      />

      <FunnelSection
        width={getWidth(0.565)}
        backgroundColor="#F0F4C3"
        title="Jobs"
        tooltip="% of matches that convert to jobs.
The number of jobs dictates the number 
of designer memberhships per territory. "
      />
    </Container>
  );
};
